import AsoHeader from "../../../components/Aso/Header";
import AsoAvisoReconhecimentoFacial from "../../../components/Aso/Register/AvisoReconhecimentoFacial";

const AvisoReconhecimentoFacial = () => {
    return(
        <div>
            <AsoHeader />
            <AsoAvisoReconhecimentoFacial />
        </div>
    );
}

export default AvisoReconhecimentoFacial;